import React, { ReactText } from 'react';
import Snackbar, { SnackbarType } from './Snackbar';

export interface Snackbar {
    id: ReactText;
    text: string;
    type: SnackbarType;
    dark?: boolean;
}

export interface SnackbarsProps {
    snackbars: Snackbar[];
    removeSnackbar: (id: ReactText) => void;
}

const Snackbars = ({ snackbars, removeSnackbar }: SnackbarsProps) => (
    <div className='snackbars'>
        {snackbars.map(x => <Snackbar key={x.id} {...x} onDisappear={() => removeSnackbar(x.id)} />)}
    </div>
);

export default Snackbars;
